import { useState } from 'react'
import { useRouter } from 'next/router'
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@headlessui/react'
import { usePopper } from 'react-popper'
import { Icon } from '@captaincause/ui/Icon'
import { NavCallToActions } from './CallToActions'
import type { ReactNode } from 'react'
import type { Localization } from '@captaincause/types'

interface HamburgerProps {
  children: ReactNode
  localizations: Localization[]
}

export function NavHamburger({ children, localizations }: HamburgerProps) {
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(
    null,
  )
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null)

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom',
    strategy: 'fixed',
    modifiers: [{ name: 'offset', options: { offset: [0, 11] } }],
  })

  const router = useRouter()

  return (
    <Popover key={router.asPath}>
      {({ open }) => (
        <>
          <PopoverButton
            ref={setReferenceElement}
            aria-label={open ? 'Close menu' : 'Open menu'}
            className="p-1"
          >
            <Icon icon={open ? 'cross' : 'menu'} size="big" />
          </PopoverButton>

          <Transition
            as={PopoverPanel}
            className="z-10 h-auto max-h-[90vh] w-full transform-gpu overflow-y-scroll bg-white p-4 shadow-lg transition-opacity duration-300 ease-out data-[closed]:opacity-0"
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
          >
            <div className="flex flex-col">{children}</div>
            <div className="mt-4 flex flex-col items-center justify-center space-y-4">
              <NavCallToActions localizations={localizations} />
            </div>
          </Transition>
        </>
      )}
    </Popover>
  )
}
